import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import { getTodayDate, selectDropdownStyle } from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import moment from "moment";
import NoDataImg from "../../../Assets/Images/no-data-img.png";
import { getExpenseByDateReport } from "./../../../Helpers/apiCalls/ExpensesReports/ExpenseReportApi";
import { getAllExpenseType } from "../../../Helpers/apiCalls/expensetypesApi";
import Footer from "../../../Components/Footer/Footer";

export default function ExpenseByDate() {
  const navigate = useNavigate();
  const dateToday = getTodayDate();

  const [inactive, setInactive] = useState(true);
  const thirtyDaysBefore = (givenDate) => {
    const newDate = new Date(givenDate);
    newDate.setDate(newDate.getDate() - 30);
    newDate.setTime(newDate.getTime() - 1);
    return newDate;
  };

  const [filterConfig, setFilterConfig] = useState({
    expense_type_per_day_date_from: thirtyDaysBefore(dateToday),
    expense_type_per_day_date_to: dateToday,
    expense_type_id: "",
  });

  const [showLoader, setShowLoader] = useState(false);
  const [noData, setNoData] = useState(false);
  const [allExpenseTypes, setAllExpenseTypes] = useState([]);
  const [filteredTypes, setFilteredTypes] = useState([]);
  const [allData, setAllData] = useState([]);
  const [lineChartData, setLineChartData] = useState([]);
  const [dateLabels, setDateLabels] = useState([]);

  function getColor(index) {
    const borderColor = [
      "rgba(255, 99, 132, 1)",
      "rgba(54, 162, 235, 1)",
      "rgba(255, 206, 86, 1)",
      "rgba(75, 192, 192, 1)",
      "rgba(153, 102, 255, 1)",
      "rgba(255, 159, 64, 1)",
    ];
    return borderColor[index % borderColor.length];
  }

  function getBackground(index) {
    const backgroundColor = [
      "rgba(255, 99, 132, 0.2)",
      "rgba(54, 162, 235, 0.2)",
      "rgba(255, 206, 86, 0.2)",
      "rgba(75, 192, 192, 0.2)",
      "rgba(153, 102, 255, 0.2)",
      "rgba(255, 159, 64, 0.2)",
    ];
    return backgroundColor[index % backgroundColor.length];
  }


  function setBg() {
      const randomColor = Math.floor(Math.random()*16777215).toString(16);
      var color = "#" + randomColor;
      return color
  }

  const lineData = {
    labels: dateLabels,
    datasets: allData.map((type) => {
      var color = setBg()
      return {
        label: type.pc_expense_type,
        data: type.total_expense_per_day,
        borderColor: color,
        backgroundColor: color,
        fill: true,
        // borderWidth: 1,
        // lineTension: 0.1,
      };
    }),
  };

//   const lineChartOptions = {
//     scales: {
//       x: {
//         display: true,
//       },
//       y: {
//         display: true,
//         ticks: { beginAtZero: true },
//       },
//     },
//   };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  );

  const handleTypeFilter = (e) => {
    if (e.value === "") {
      setFilteredTypes(allExpenseTypes);
    } else {
      setFilteredTypes([e]);
    }

    setFilterConfig((prev) => {
      return { ...prev, expense_type_id: e.value };
    });
  };

  useEffect(() => {
    async function fetchData() {
      setShowLoader(true);

      const response = await getExpenseByDateReport(filterConfig);

      if (response.error) {
        setNoData(true);
      } else {
        const labels = [];
        const values = [];
        const dates = [];

        response.data.data.map((row) => {
          labels.push(`${row.pc_expense_type}`);
          values.push(row.total_expense_per_day);
          dates.push(row.expense_date);
        });

        setAllData(response.data.data)
        setDateLabels(dates)
        setLineChartData({ labels: labels, data: values });
        // const tempLineData = {};
        // response.data.data.map((row, index) => {
        //   filteredTypes.map((type) => {
        //     if (!tempLineData[type.name]) {
        //       tempLineData[type.name] = [];
        //     }

        //     var tempDate = moment(row).format("MMM DD, YYYY");

        //     if (
        //       row.pc_expense_type &&  
        //       row.pc_expense_type.includes(type.name)
        //     ) {
        //       var info = {};
        //       info.x = tempDate;
        //       info.y = row.total_expense_per_day;
        //       tempLineData[type.name].push(info);
        //     } else {
        //       var info = {};
        //       info.x = tempDate;
        //       info.y = 0;
        //       tempLineData[type.name].push(info);
        //     }
        //   });
        // });
        // setLineChartData(tempLineData);
        setNoData(false);
      }
      setShowLoader(false);
    }

    fetchData();
  }, [filterConfig]);

  useEffect(() => {
    async function fetchAllExpenseTypes() {
      const response = await getAllExpenseType();
      if (response.data) {
        const res = response.data.map((row) => {
          var info = {};
          info.value = row.id;
          info.label = row.name;
          info.name = row.name;
          return info;
        });
        setAllExpenseTypes(res);
        setFilteredTypes(res);
      }
    }

    fetchAllExpenseTypes();
  }, []);


  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"EXPENSES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={9}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> EXPENSE BY DATE </h1>
          </Col>
          <Col lg={3} className="mt-2 mt-lg-0">
              <div className="PO-filters">
                <button
                  type="button"
                  className="primary-btn"
                  onClick={() =>
                    navigate("/expenses", {
                      state: {
                        dateFrom: Moment(filterConfig.date_from).format(
                          "MM-DD-YYYY"
                        ),
                        dateTo: Moment(filterConfig.date_to).format("MM-DD-YYYY"),
                      },
                    })
                  }
                >
                  View
                </button>
              </div>
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                name="type"
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Expense Type..."
                styles={selectDropdownStyle}
                selected={allExpenseTypes.map(
                  (item) => item.label === filterConfig.expense_type
                )}
                options={[{ label: "All", value: "" }, ...allExpenseTypes]}
                onChange={(e) =>
                  setFilterConfig((prev) => {
                    return { ...prev, expense_type: e.value, expense_type_name: e.label };
                  })
                }
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                selected={filterConfig.date_from}
                name="date_from"
                placeholderText={Moment().format("MM/DD/YYYY")}
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date };
                  });
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
                <DatePicker
                  selected={filterConfig.date_to}
                  name="date_to"
                  placeholderText={Moment().format("MM/DD/YYYY")}
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
            </Col>
          </Row>
          <div className="mb-2" />
          <div className="below d-flex justify-content-center mb-5 mt-3">
            {!noData ? (
              <Line
                className="chart-size"
                data={lineData}
                // options={lineChartOptions}
              />
            ) : (
              <div className="no-data-cont">
                <img
                  src={NoDataImg}
                  alt="no data found"
                  className="no-data-small"
                />
                <span>Uh Oh! No data found.</span>
              </div>
            )}
          </div>
          <div className="mb-2" />
        </div>
      </div>
      <Footer/>
    </div>
  );
}
